(function () {
  const root = document.querySelector('.mirage-homepage');
  if (!root) return;

  const zane = root.querySelector('[data-zane-story]');
  if (zane) {
    const mainLink = zane.querySelector('[data-zane-main-link]');
    const mainImage = zane.querySelector('[data-zane-main-image]');
    const name = zane.querySelector('[data-zane-name]');
    const status = zane.querySelector('[data-zane-status]');
    const action = zane.querySelector('[data-zane-action]');
    const dot = zane.querySelector('[data-zane-dot]');
    const options = Array.from(zane.querySelectorAll('[data-zane-option]'));

    const selectColor = (option) => {
      const available = option.dataset.available === 'true';
      mainLink.href = option.href;
      mainImage.src = option.dataset.image;
      mainImage.alt = `${option.dataset.name} IZOD Zane three-piece luggage set`;
      name.textContent = option.dataset.name;
      status.textContent = available ? 'Available now' : 'Currently out of stock';
      action.href = option.href;
      action.firstChild.textContent = `${available ? 'Shop' : 'View'} Zane in ${option.dataset.name} `;
      dot.style.backgroundColor = option.dataset.swatch;
      options.forEach((item) => item.removeAttribute('aria-current'));
      option.setAttribute('aria-current', 'true');
    };

    options.forEach((option) => {
      option.addEventListener('mouseenter', () => selectColor(option));
      option.addEventListener('focus', () => selectColor(option));
    });
  }

  const detailStory = root.querySelector('[data-detail-story]');
  if (detailStory) {
    const image = detailStory.querySelector('[data-detail-image]');
    const options = Array.from(detailStory.querySelectorAll('[data-detail-option]'));
    let activeIndex = 0;
    let timer;

    const selectDetail = (option) => {
      const nextIndex = options.indexOf(option);
      if (nextIndex < 0 || nextIndex === activeIndex) return;
      activeIndex = nextIndex;
      image.classList.add('is-changing');
      window.setTimeout(() => {
        image.src = option.dataset.image;
        image.alt = `Close view of the ${option.dataset.name.toLowerCase()} Zane luggage shell and logo`;
        detailStory.style.setProperty('--detail-tone', option.dataset.tone);
        detailStory.style.setProperty('--detail-image-filter', option.dataset.filter);
        options.forEach((item) => item.setAttribute('aria-pressed', item === option ? 'true' : 'false'));
        image.classList.remove('is-changing');
      }, 180);
    };

    const restart = () => {
      window.clearInterval(timer);
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        timer = window.setInterval(() => selectDetail(options[(activeIndex + 1) % options.length]), 4300);
      }
    };

    options.forEach((option) => option.addEventListener('click', () => {
      selectDetail(option);
      restart();
    }));
    restart();
  }

  const gallery = root.querySelector('.isla-film');
  if (gallery && 'IntersectionObserver' in window) {
    const videos = Array.from(gallery.querySelectorAll('video'));
    const observer = new IntersectionObserver(([entry]) => {
      videos.forEach((video) => entry.isIntersecting ? video.play().catch(() => {}) : video.pause());
    }, { threshold: 0.18 });
    observer.observe(gallery);
  }
})();
